import axios from 'axios'

export default class Http {
  constructor(app) {
    this.service = axios.create({});    
    this.app = app
    this.interceptors();
  }
  get(path){
    return this.service.get(path);
  }
  post(path, payload){
    return this.service.post(window.location.href, payload, {
      headers: {
        'X-OCTOBER-REQUEST-HANDLER': path,
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
  }
  interceptors() {
    let app = this.app
    this.service.interceptors.request.use((config) => {
      this.app.$root.$emit('before-axios');
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    this.service.interceptors.response.use((response) => {
      this.app.$root.$emit('after-axios');
      return response;
    }, function (error) {
      app.$root.$emit('after-axios')
      return Promise.reject(error);
    });
  }
}

